import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { RootState } from 'redux/schemas';
import { getAiRolePlayAvailableAvatars } from 'redux/actions/ai-role-play';

let isRequestInFlight = false;
let lastFetchedCatalogId: string | null = null;

/* @ngInject */
export default function useAiRolePlayAvatarOptions(catalogId: string) {
  const dispatch = useAppDispatch();
  const avatarOptions = useSelector((state: RootState) => state.models.aiRolePlayAvailableAvatars);

  useEffect(() => {
    if (catalogId
      && !isRequestInFlight
      && (lastFetchedCatalogId !== catalogId || !avatarOptions.length)
    ) {
      isRequestInFlight = true;
      lastFetchedCatalogId = catalogId;
      dispatch(getAiRolePlayAvailableAvatars({ catalogId })).finally(() => {
        isRequestInFlight = false;
      });
    }
  }, [avatarOptions.length, catalogId, dispatch]);

  return avatarOptions;
}
